import HomeHeader from "../HomePage/components/HomeHeader";
// import "../Homepage/home.css";
import CallIcon from "@mui/icons-material/Call";
import "../CampaignPage/styles.css";
import MobileInput from "../../Components/MobileInput/MobileInput";
import { ChangeEvent, useState } from "react";
import { CircularProgress, Dialog } from "@mui/material";
import { useSnackbar } from "../../context/SnackbarContext";
import UploadResume from "./UploadResume";
import {
  fetchPresignedUrl,
  registerEmirati,
  uploadResume,
} from "../../api/register";
import { populateFormDataWithType } from "../Utils/formData";

const RegisterPage = () => {
  const handleGuide = () => {
    window.open(
      "https://tascoutsourcing.com/campaigns/emiratization-guidebook/",
      "_blank"
    );
  };

  const [file, setFile] = useState<File | null>(null);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phoneNumber: "",
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setForm((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePhoneChange = (value: string) => {
    setForm((prevState) => ({
      ...prevState,
      ["phoneNumber"]: value,
    }));
  };

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { showSnackbar } = useSnackbar();

  const handleSubmit = async () => {
    setLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      showSnackbar("Please enter a valid email address", "error");
      setLoading(false);

      return;
    }

    if (form.phoneNumber.length < 10 || form.phoneNumber.length > 15) {
      showSnackbar(
        "Phone number should be between 10 and 15 characters",
        "error"
      );
      setLoading(false);

      return;
    }

    if (file) {
      const resumeFormData = new FormData();

      resumeFormData.append("fileExtension", file.type.split("/")[1]);
      resumeFormData.append("contentType", file.type);

      const resp = await fetchPresignedUrl(resumeFormData);

      if (resp) {
        const formData = new FormData();
        populateFormDataWithType(formData, resp.preSignedUrl, file);
        const uploaded = await uploadResume(resp.preSignedUrl.url, formData);
        if (uploaded) {
          if (
            !!form.name.length &&
            !!form.email.length &&
            !!form.phoneNumber.length
          ) {
            const registered = await registerEmirati({
              formData: [
                { key: "name", value: form.name },
                { key: "email", value: form.email },
                { key: "phoneNumber", value: form.phoneNumber },
                { key: "resume", value: resp.fileUrl },
              ],
            });
            if (registered) {
              setSubmitted(true);
            }
          } else {
            showSnackbar("Please enter all the details", "error");
          }
        } else {
          showSnackbar("Failed to upload resume, please try again", "error");
        }
      } else {
        showSnackbar("Failed to register, please try again", "error");
      }
    } else {
      if (
        !!form.name.length &&
        !!form.email.length &&
        !!form.phoneNumber.length
      ) {
        const registered = await registerEmirati({
          formData: [
            { key: "name", value: form.name },
            { key: "email", value: form.email },
            { key: "phoneNumber", value: form.phoneNumber },
          ],
        });
        if (registered) {
          setSubmitted(true);
        }
      } else {
        showSnackbar("Please enter all the details", "error");
      }
    }

    setLoading(false);
  };

  return (
    <div className="main_home_container">
      <HomeHeader />
      <div className="home_section_1">
        {submitted ? (
          <div className="max_home_width">
            <div className="home_section_1_wrapper">
              <div className="home_section_1_content">
                <div>
                  <h1 className="main_content_text max_text_width fs-48">
                    <span className="ft_text">Success!</span>
                    <span className="text-white">
                      {" "}
                      Your form has been submitted
                    </span>
                  </h1>
                  <h3 className="main_content_text max_text_width text-white">
                    You will receive an email from us shortly.
                  </h3>
                </div>
                <div className="display_center">
                  <div onClick={handleGuide} className="callButton">
                    <CallIcon />
                    {/* <img src={arrowImg} alt="logo" className="home_arrow_btn" /> */}
                    <div>Contact Us</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="max_home_width">
            <div className="home_section_1_wrapper">
              <div className="home_section_1_content">
                <h1 className="main_content_text_left max_text_width fs-48">
                  <span className="ft_text">Register with us!</span>
                  <span className="text-white"> Submit Your Details</span>
                </h1>
              </div>
              <div className="home_form_container">
                <div className="main_content_text_left max_text_width">
                  <span className="ft_text_2 fs-32">Fill in your details</span>
                </div>
                <div className="home_form_line_wrapper">
                  <div className="ak_form_input_wrapper">
                    <input
                      className="ak_form_input"
                      type="text"
                      placeholder="Name*"
                      onChange={handleChange}
                      name="name"
                      value={form.name}
                    />
                  </div>
                  <div className="ak_form_input_wrapper">
                    <input
                      className="ak_form_input"
                      type="email"
                      placeholder="Email*"
                      onChange={handleChange}
                      name="email"
                      value={form.email}
                    />
                  </div>
                </div>
                <div className="home_form_line_wrapper">
                  <MobileInput handleChange={handlePhoneChange} />
                </div>
                <div>
                  <p className="bold">Upload Resume (optional)</p>
                  <UploadResume file={file} setFile={setFile} />
                </div>
                <div
                  onClick={handleSubmit}
                  className="callButton form_submit_btn"
                >
                  <div>Register</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Dialog open={loading}>
        <div className="submit_loader">
          <CircularProgress color="inherit" size={30} />
        </div>
      </Dialog>
    </div>
  );
};

export default RegisterPage;
